<div class="container">
  <p class="title">{{ plan.title | uppercase }}</p>
  <p class="price">
    <span class="price symbol">$</span
    ><span class="price value">{{ plan.price }}</span>
  </p>
  <a
    class="action"
    [routerLink]="signupLink"
    merriNoFocusLink
    >{{ plan.action }}</a
  >
  <p class="description">{{ plan.description }}</p>

  <ul *ngIf="plan.features" class="features">
    <li *ngFor="let feature of plan.features" class="feature">
      {{ feature }}
    </li>
  </ul>
</div>
